import * as React from 'react';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { FieldRenderProps } from 'react-final-form';
import { FC } from 'react';
import { Theme, styled } from '@material-ui/core';

type Props = FieldRenderProps<string, HTMLElement> & {
  label?: string;
};

const StyledSelect = styled(Select)<Theme>(({ theme }) => ({
  width: '100%',
  '& .MuiSelect-root': {
    background: theme.palette.common.white,
    border: theme.config.defaultBorder(),
    borderRadius: theme.config.defaultBorderRadius,
    boxShadow: theme.config.defaultBoxShadow,
    padding: theme.spacing(2),
    fontSize: theme.typography.h3.fontSize,
    color: theme.palette.grey[900],

    '&:before': {
      borderBottom: 'none',
    },
  },
}));

const SelectAdapter: FC<Props> = ({
  input: { name, value, onChange, ...restInput },
  meta,
  label,
  ...rest
}) => {
  const showError =
    ((meta.submitError && !meta.dirtySinceLastSubmit) || meta.error) && meta.touched;

  return (
    <div>
      <StyledSelect
        {...rest}
        name={name}
        onChange={onChange}
        inputProps={restInput}
        value={value}
        disableUnderline
      />

      {showError && <FormHelperText>{meta.error || meta.submitError}</FormHelperText>}
    </div>
  );
};

export default SelectAdapter;
